import * as React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-12 w-full rounded-2xl border-2 border-brand-light bg-white px-4 py-2 text-base text-brand-dark placeholder:text-gray-400 transition-all duration-200',
          'dark:border-dark-border dark:bg-dark-bg dark:text-dark-text dark:placeholder:text-dark-muted',
          'focus:border-brand-dark focus:outline-none focus:ring-0',
          'dark:focus:border-dark-text',
          'disabled:cursor-not-allowed disabled:opacity-50',
          error && 'border-error-text focus:border-error-text',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
